import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import photoAvatar from 'src/examples/Avatars/photo';
import sizesAvatar from 'src/examples/Avatars/size';
import textsAvatar from 'src/examples/Avatars/text';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  photoAvatar,
  sizesAvatar,
  textsAvatar,
  React
};